export enum DateTimeUtilityFilter {
  ALL = "ALL",
  DAYS_ONLY = "DAYS_ONLY",
  HOURS_ONLY = "HOURS_ONLY",
  TOTAL_MINS_ONLY = "MINS_ONLY",
  EXCEPT_SECONDS = "EXCEPT_SECONDS"
}

function getDisplayHideZero(dtVal: any, strVal: string) {
  if (dtVal === 1) {
    return dtVal + " " + strVal.substring(0, strVal.length - 1);
  } else {
    return dtVal > 0 ? dtVal + " " + strVal : "";
  }
}

function trimCommas(str) {
  const trimmedString = str.replace(/^[\s,]+|[\s,]+$/g, "");
  return trimmedString;
}

export const DateTimeUtility = {
  getDateTimeComponents: dateTime => {
    const totalMinutes = Math.floor(dateTime / (1000 * 60));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;
    const seconds = Math.floor((dateTime / 1000) % 60);

    return {
      days,
      hours,
      minutes,
      seconds,
      totalMinutes
    };
  },
  getDateTimeDisplay: (dtObj, filter: DateTimeUtilityFilter) => {
    switch (filter) {
      case DateTimeUtilityFilter.ALL:
        return trimCommas(
          getDisplayHideZero(dtObj.days, "days") +
            ", " +
            getDisplayHideZero(dtObj.hours, "hours") +
            ", " +
            getDisplayHideZero(dtObj.minutes, "mins") +
            ", " +
            getDisplayHideZero(dtObj.seconds, "secs")
        );
      case DateTimeUtilityFilter.EXCEPT_SECONDS:
        return trimCommas(
          getDisplayHideZero(dtObj.days, "days") +
            ", " +
            getDisplayHideZero(dtObj.hours, "hours") +
            ", " +
            getDisplayHideZero(dtObj.minutes, "mins")
        );
      case DateTimeUtilityFilter.DAYS_ONLY:
        return dtObj.days + " days";
      case DateTimeUtilityFilter.HOURS_ONLY:
        return dtObj.hours + " hours";
      case DateTimeUtilityFilter.TOTAL_MINS_ONLY:
        return dtObj.totalMinutes + " mins";
    }
  }
};
